/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';


const Svg = styled.svg`

  overflow: visible;

  stroke-linecap: round;
  stroke-linejoin: round;

  --icon-color-1:   var(--gray-1);
  --icon-color-2:   var(--gray-2);
  --icon-color-3:   var(--gray-3);
  --icon-color-4:   var(--gray-4);
  --icon-color-5:   var(--gray-5);
  --icon-color-6:   var(--gray-6);
  --icon-color-7:   var(--gray-7);
  --icon-color-8:   var(--gray-8);
  --icon-color-9:   var(--gray-9);
  --icon-color-10:  var(--gray-10);
  --icon-color-11:  var(--gray-11);
  --icon-color-12:  var(--gray-12);

  --icon-color-a1:  var(--gray-a1);
  --icon-color-a2:  var(--gray-a2);
  --icon-color-a3:  var(--gray-a3);
  --icon-color-a4:  var(--gray-a4);
  --icon-color-a5:  var(--gray-a5);
  --icon-color-a6:  var(--gray-a6);
  --icon-color-a7:  var(--gray-a7);
  --icon-color-a8:  var(--gray-a8);
  --icon-color-a9:  var(--gray-a9);
  --icon-color-a10: var(--gray-a10);
  --icon-color-a11: var(--gray-a11);
  --icon-color-a12: var(--gray-a12);

  &[data-accent] {
    --icon-color-1:   var(--accent-1);
    --icon-color-2:   var(--accent-2);
    --icon-color-3:   var(--accent-3);
    --icon-color-4:   var(--accent-4);
    --icon-color-5:   var(--accent-5);
    --icon-color-6:   var(--accent-6);
    --icon-color-7:   var(--accent-7);
    --icon-color-8:   var(--accent-8);
    --icon-color-9:   var(--accent-9);
    --icon-color-10:  var(--accent-10);
    --icon-color-11:  var(--accent-11);
    --icon-color-12:  var(--accent-12);

    --icon-color-a1:  var(--accent-a1);
    --icon-color-a2:  var(--accent-a2);
    --icon-color-a3:  var(--accent-a3);
    --icon-color-a4:  var(--accent-a4);
    --icon-color-a5:  var(--accent-a5);
    --icon-color-a6:  var(--accent-a6);
    --icon-color-a7:  var(--accent-a7);
    --icon-color-a8:  var(--accent-a8);
    --icon-color-a9:  var(--accent-a9);
    --icon-color-a10: var(--accent-a10);
    --icon-color-a11: var(--accent-a11);
    --icon-color-a12: var(--accent-a12);
  }

  --icon-stroke-width-normal: 2;

  --icon-fill-normal: var(--icon-color-5);

  --icon-stroke-text: var(--icon-color-12);
  --icon-stroke-normal: var(--icon-color-11);


  & * {
    vector-effect: non-scaling-stroke;

    transition-property: all;
    transition-duration: var(--icon-transition-duration, 0.2s);
    transition-timing-function: var(--icon-transition-function, ease);
  }
`;


const IconSvg = ({ size, accent, ...props }) =>
(
  <Svg {...props} width = {size} height = {size} viewBox = '-12 -12 24 24' data-accent = {accent || undefined} />
);


IconSvg.size = 24;


export default IconSvg;
